import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Form, Input, Button, message } from 'antd';

import MUTATION from '../graphql/mutations/storePbaSecurityMutation.graphql';
import QUERY from '../graphql/queries/getCustomerPbaQuery.graphql';
import validationRegex from '../utils/validationRegex';

const FormItem = Form.Item;
const { TextArea } = Input;

class PbaSecuritiesForm extends Component {
  state = {
    submittingForm: false,
  };

  handleSubmit = (event) => {
    this.setState({
      submittingForm: true,
    });
    event.preventDefault();
    this.props.form.validateFieldsAndScroll((err, { address, ...values }) => {
      const { pba_id } = this.props;
      if (!err) {
        this.props.mutate({
          variables: { pba_id, security: { id: (+new Date()).toString(36), ...values, address: address.replace(/\r?\n|\r/g, ' ') } },
          update: (cache, { data: { newPbaSecurities } }) => {
            const data = cache.readQuery({
              query: QUERY,
              variables: { id: pba_id },
            });
            data.customerPba.securities = newPbaSecurities;
            cache.writeQuery({ query: QUERY, variables: { id: pba_id }, data });
          },
        })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            this.props.form.resetFields();
            message.success('Success!');
          })
          .catch((mutateErr) => {
            console.log(mutateErr);
            this.setState({
              submittingForm: false,
            });
            message.error(mutateErr.message);
          });
      } else {
        console.log(err);
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit} layout="vertical" className="bank-form">
        <FormItem
          label="Street address"
        >
          {
            getFieldDecorator(
              'address',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<TextArea rows={4} />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="City"
        >
          {
            getFieldDecorator(
              'city',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="State"
        >
          {
            getFieldDecorator(
              'state',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Pincode"
        >
          {
            getFieldDecorator(
              'pincode',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                  {
                    pattern: validationRegex.pincode,
                    message: 'Pincode incorrect!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Property Type"
        >
          {
            getFieldDecorator(
              'property_type',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                  {
                    type: 'string',
                    message: 'Incorrect value!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Owned By"
        >
          {
            getFieldDecorator(
              'owned_by',
              {
                rules: [
                  {
                    required: true,
                    message: 'Incorrect value!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Plot Area"
        >
          {
            getFieldDecorator(
              'plot_area',
              {
                rules: [
                  {
                    pattern: validationRegex.float,
                    message: 'Incorrect value!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Construction Area"
        >
          {
            getFieldDecorator(
              'construction_area',
              {
                rules: [
                  {
                    pattern: validationRegex.float,
                    message: 'Incorrect value!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Valuation"
        >
          {
            getFieldDecorator(
              'valuation',
              {
                rules: [
                  {
                    pattern: validationRegex.float,
                    message: 'Incorrect value!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem className="form-item-block">
          <Button type="primary" htmlType="submit" loading={this.state.submittingForm}>Submit</Button>
        </FormItem>
      </Form>
    );
  }
}

PbaSecuritiesForm.propTypes = {
  mutate: PropTypes.func.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  pba_id: PropTypes.string.isRequired,
};

export default compose(
  graphql(MUTATION),
  Form.create(),
)(PbaSecuritiesForm);



// WEBPACK FOOTER //
// ./src/forms/PbaSecuritiesForm.jsx